import Vue from 'vue';
import Multiselect from 'vue-multiselect';
import Treeselect, { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import { Validator } from 'vee-validate';

import User from '@/models/User.js';
import Address from '@/models/Address.js';

import preloader from '@/components/preloader/index.vue';
import buttonLoader from '@/components/button';

import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import { REGEX } from '@/utils/const';

import Api from '@/utils/api';

export default Vue.extend({
  components: {
    preloader,
    Multiselect,
    Treeselect,
    buttonLoader,
  },
  data () {
    return {
      user: new User({}),
      address: new Address({}),
      contacts: {
        Phone: '',
        AdditionalEmail: '',
        Fax: '',
        Ftp: '',
      },
      request: {
        address: {},
        user: {},
        contacts: {},
      },

      password: '',
      confirmPassword: '',
      message: '',

      passwordRegex: REGEX.passwordRegex,
      emailRegex: REGEX.emailRegex,
      userNameRegex: REGEX.userNameRegex,

      valueTree: [],
      SelectedLanguages: [],
      languagesOpt: [],
      hidePassword: true,
      loadingButton: false,
      textCategoryList: [],
      titles: [],
      optionsTree: [],
      countries: [],
      accountTypes: [],
      companies: [],
      selectIndividual: false,
      showInfoPassword: false,
      classPasswordStrength: 'weak',
      widthPasswordStrength: '20',
      load: false,
      typeResponse: '',
      tab: 1,
    };
  },
  watch: {
    'user.PasswordHash' (password) {
      var count = 0;
      var rules = [
        '[!@#$%^&*+-]',
        '[A-Z]',
        '[0-9]',
        '[a-z]',
        '.{6,}',
      ];

      for (var i = 0; i < rules.length; i++) {
        if (new RegExp(rules[i]).test(password)) {
          count += 20;
        }
      }
      if (count <= 20 || count < 40) {
        this.classPasswordStrength = 'weak';
      } else if (count >= 40 && count < 80) {
        this.classPasswordStrength = 'medium';
      } else if (count >= 80) {
        this.classPasswordStrength = 'strong';
      }

      if (password === '') {
        count = 0;
      }

      this.widthPasswordStrength = count;
    },
    'user.Individual' (newVal, oldVal) {
      if (newVal) {
        this.address.CompanyName = '';
        this.address.Department = '';
      }
    },
  },
  computed: {
    passwordType () {
      return this.hidePassword ? 'password' : 'text';
    },
    checkAccountType () {
      if (this.user.AccountTypeID) {
        if (this.user.AccountTypeID.ID === 3 || this.user.AccountTypeID.ID === 4) {
          return true;
        }
      }

      return false;
    },
  },
  mounted () {
    Promise.all([
      this.getLanguages(),
      this.getThreeOptioins(),
      this.getCountries(),
      this.getAccountTypes(),
      this.getCompanies(),
      this.getAllTitles(),
      this.getDocumentTypes(),
      this.checkUniqName(),
    ]).then(() => {
      this.load = true;
    });
  },
  methods: {

    /**
         * Method return string for multiselect
         *
         * @param {Number} count
         */
    limitText (count) {
      return `and ${count} others`;
    },

    /**
         * Check uniq rules
         */
    checkUniqName () {
      const unique = (value) => {
        return Api.registration.checkUserData({
          Request: {
            login: value,
          },
        }).then((data) => {
          return data.data.Status ? { valid: true } : {
            valid: false,
            data: {
              message: `${value} is already taken.`,
            },
          };
        });
      };
      Validator.extend('unique', {
        validate: unique,
        getMessage: (field, params, data) => data.message,
      });
      return Promise.resolve();
    },

    /**
         * Change tab registration
         *
         * @param {String} form
         * @param {Number} tab
         */
    changeTab (form, tab) {
      if (!form) {
        this.tab = tab;
        return;
      }

      this.$validator.validateAll(form)
        .then((result) => {
          if (result) {
            this.tab = tab;
          }
        });

      return false;
    },

    /**
         * Get documents types
         */
    getDocumentTypes () {
      return this.$store.dispatch('GET_DOCUMENT_TYPES').then((data) => {
        this.textCategoryList = data;
      });
    },

    /**
         * Get all titles
         */
    getAllTitles () {
      return this.$store.dispatch('GET_USER_TITLES').then((data) => {
        this.titles = data;
      });
    },

    /**
         * Get all industry sectors
         */
    getThreeOptioins () {
      return this.$store.dispatch('GET_INDUSTRY_TREE').then((data) => {
        this.optionsTree = data;
      });
    },

    /**
         * Get countries
         */
    getCountries () {
      return this.$store.dispatch('GET_COUNTRIES').then((data) => {
        this.countries = data;
      });
    },

    /**
         * Get account types
         */
    getAccountTypes () {
      return this.$store.dispatch('GET_ACCOUNT_TYPES').then((data) => {
        this.accountTypes = data;
      });
    },

    /**
         * Get companies
         */
    getCompanies () {
      return Api.registration
        .getAllCompanies()
        .then((data) => {
          if (data.status) {
            this.companies = data.data;
          }
        });
    },

    /**
         * Get languages
         */
    getLanguages () {
      return this.$store.dispatch('GET_LANGUAGES').then((data) => {
        this.languages = data;
        this.languagesOpt = this.languages.map((i) => ({
          id: i.ID,
          label: i.LanguageName,
          customLabel: i.CountryISOCode,
        }));
      });
    },

    /**
         * Register user
         */
    register () {
      Api.registration
        .sendUserData(this.handlerParams())
        .then((data) => {
          if (data.data.Status) {
            this.loadingButton = false;
            this.message = `You successfully registered. Please check your inbox ${this.user.Email} for confirmation message`;
            this.typeResponse = 'success';
            this.tab = 4;

            setTimeout(() => {
              this.$router.push({ name: 'auth' });
            }, 4000);
          } else {
            this.loadingButton = false;
            this.message = 'Something go wrong';
            this.typeResponse = 'fail';
            this.tab = 4;
          }
        });
    },

    /**
         * Transform parametrs for query
         */
    handlerParams () {
      this.loadingButton = true;
      this.user.SelectedLanguages = this.SelectedLanguages;
      this.user.SelectedSectors = this.valueTree;
      this.user.DocumentTypeIds = this.user.DocumentTypeIds.map((item) => item.ID).join(',');
      this.user.title = this.user.title.Name;
      this.user.AccountTypeID = this.user.AccountTypeID.ID;

      this.request.address = this.address;
      this.request.user = this.user;
      this.request.contacts = this.contacts;

      return this.request;
    },

    /**
         * This method for load languges
         *
         * @param {Object} param
         */
    loadOptions ({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        const option = this.languagesOpt.filter((name) => name.label.toLowerCase().match(searchQuery));
        callback(null, option);
      }
    },
  },
});
